import { t } from 'i18next';
import { includes } from 'ramda';

export const getErrorMessage = (err) => {
  if (includes('already registered', err.message)) {
    return t('modules.dictionary.0');
  }
  const errorCodes = [{ code: 'INTERNAL_SERVER_EROR', message: t('modules.dictionary.1') }];
  const message = (errorCodes.find((item) => item.code === err.code) || {}).message;

  return message ? message : err.message;
};
